var MDB = window.MDB || {};

(function(){
    $.extend(MDB, {
        downloadDocument: function(opts){
            $.extend({
                defaultFilename: 'download',
                requestMethod: 'GET',
                url: undefined,
                element: undefined,
                requestData: null
            }, opts);
           
            if(opts.element){
                var $element = $(opts.element);
                var nodeName = $element.prop('nodeName');

                if (nodeName === 'FORM') {
                    if (!opts.url) {
                        opts.url = $element.prop('action');
                    }

                    opts.requestMethod = $element.prop('method') || opts.requestMethod;
                    opts.requestData = new FormData($element[0]);

                    $element.first().find('textarea').each(function(){
                        var me = $(this);

                        opts.requestData.set(me.prop('name'), me.val());
                    })
                }

                if (nodeName === 'A' && !opts.url) {
                    opts.url = $element.prop('href');
                }
            }

            showLoader();
            var request = new XMLHttpRequest();

            request.onload = function (e) {
                if (this.status == 200) {
                    var contentDispositionHeader = this.getResponseHeader('content-disposition');
                    var filename = opts.defaultFilename;

                    if (contentDispositionHeader) {
                        contentDispositionHeader = _.map(contentDispositionHeader.split(';'), _.trimStart);

                        filename = _.find(contentDispositionHeader, function (e) {
                            return _.startsWith(e, 'filename'); 
                        });
                        filename = filename.split('=')[1].replace(/"/g, '');
                    }


                    var blob = new Blob([this.response], {type: 'image/pdf'});

                    if(window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveOrOpenBlob(blob, filename);
                    } else{
                        var a = document.createElement("a");
                        a.style = "display: none";
                        document.body.appendChild(a);

                        var url = window.URL.createObjectURL(blob);

                        a.href = url;
                        a.download = filename;
                        a.click();

                        window.URL.revokeObjectURL(url);
                       
                        a.remove();
                    }

                    hideLoader();
                } else {
                    hideLoader();
                    MDB.alert('Er is een fout opgetreden tijdens het downloaden van het opgevraagde document', 'Download mislukt');
                }
            };

            request.open(opts.requestMethod, opts.url, true);
            request.responseType = 'blob';

            request.send(opts.requestData);
        } 
    });
    
    function showLoader(){
        MDB.UI.Loader.show();
    }
    
    function hideLoader(){
        MDB.UI.Loader.hide();
    }
})();